import {Routes} from '@angular/router';
import {AppLayout} from '@/layout/components/app.layout';
import { canActivateAuthRole } from '@/shared/guards/auth-role.guard';
import { APM_EXTRACAO_ROLES_LEITURA } from '@/shared/models/apm-extracao.model';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [canActivateAuthRole],
        data: { roles: ['geo-visualizer-web.user_access'] },
        children: [
            {
                path: '',
                data: {
                    breadcrumb: 'Home',
                    roles: ['geo-visualizer-web.user_access']
                },
                loadComponent: () => import('./app/pages/home/home').then((c) => c.HomeComponent)
            },
            {
                path: 'inspecao',
                data: {
                    breadcrumb: 'Open Building por endereço',
                    roles: ['geo-visualizer-web.access_produto_1']
                },
                loadChildren: () => import('./app/modules/inspecao/inspection.routes')
            },
            {
                path: 'apm',
                data: {
                    breadcrumb: 'Áreas Públicas Municipais',
                    roles: ['geo-visualizer-web.access_apm']
                },
                loadChildren: () => import('./app/modules/apm/apm.routes')
            },
            {
                path: 'apm-do',
                data: {
                    breadcrumb: 'Diários Oficiais das APMs',
                    roles: ['geo-visualizer-web.access_apm']
                },
                loadChildren: () => import('./app/modules/apm-do/apm-do.routes')
            },
            {
                path: 'apm-extracao',
                data: {
                    breadcrumb: 'Extração de APMs - Armário',
                    // Espelha a matriz de roles do apm-extractor (qualquer
                    // role do serviço dá acesso de leitura ao módulo)
                    roles: APM_EXTRACAO_ROLES_LEITURA
                },
                loadChildren: () => import('./app/modules/apm-extracao/apm-extracao.routes')
            },
            {
                path: 'mapeamento-urbano',
                data: {
                    breadcrumb: 'Mapeamento Urbano',
                    roles: ['geo-visualizer-web.access_produto_1']
                },
                loadChildren: () => import('./app/modules/mapeamento-urbano/mapeamento-urbano.routes').then(m => m.MAPEAMENTO_URBANO_ROUTES)
            },
            // Compatibilidade: URLs antigas salvas continuam funcionando
            { path: 'empreendimento-gyn/:analiseId', redirectTo: 'mapeamento-urbano/:analiseId' },
            { path: 'empreendimento-gyn', redirectTo: 'mapeamento-urbano' },
            {
                path: 'iptu',
                data: {
                    breadcrumb: 'Análise de Valor Venal - IPTU',
                    roles: ['geo-visualizer-web.access_produto_3']
                },
                loadChildren: () => import('./app/modules/iptu/iptu.routes')
            },
            {
                path: 'analise',
                data: {
                    breadcrumb: 'Análise de Construções',
                    roles: ['geo-visualizer-web.gerenciar_analises']
                },
                loadChildren: () => import('./app/modules/analise/analise.routes')
            },
            {
                path: 'feedbacks',
                data: {
                    breadcrumb: 'Feedbacks',
                    roles: ['geo-visualizer-web.feedbacks']
                },
                loadChildren: () => import('./app/modules/feedback/feedback.routes')
            },
            {
                path: 'monitoramento',
                data: {
                    breadcrumb: 'Monitoramento Temporal',
                    roles: ['geo-visualizer-web.access_produto_1']
                },
                loadChildren: () => import('./app/modules/monitoramento/monitoramento.routes')
            },
        ]
    },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: 'notfound', loadComponent: () => import('./app/pages/notfound/notfound').then((c) => c.Notfound) },
    { path: '**', redirectTo: '/notfound' }
];
